/* How a Clara document's review date reads in Backstage.

   UTSW, Nitya 15 Sep: surface policies past their review date "somewhere in the
   backstage/admin view ... That would help us identify policies that need updating", and
   let a site confirm "this is the most recent version we have" with a reminder later. */

export const ACKNOWLEDGE_OPTIONS = [30, 90, 180]

export function fmtDay(iso) {
	if (!iso) return null
	const [year, month, day] = iso.split("-").map(Number)
	return new Date(Date.UTC(year, month - 1, day)).toLocaleDateString(undefined, {
		day: "numeric", month: "short", year: "numeric", timeZone: "UTC",
	})
}

export function reviewLabel(document) {
	const due = fmtDay(document?.next_review_date)
	switch (document?.review_status) {
		case "overdue":
			return { tone: "overdue", text: `Overdue since ${due}` }
		case "acknowledged":
			return { tone: "acknowledged", text: `Latest version confirmed until ${fmtDay(document.review_acknowledged_until)}` }
		case "current":
			return { tone: "current", text: `Review due ${due}` }
		default:
			return { tone: "unknown", text: "No review date" }
	}
}

export function overdueCount(documents = []) {
	return documents.filter(document => document.review_status === "overdue").length
}
